import React, { Component } from "react";
import GalleryImagev1 from "../components/GalleryImagev1";
import GalleryImagev2 from "../components/GalleryImagev2";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import MetaTags from 'react-meta-tags'
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import "react-image-gallery/styles/css/image-gallery.css";

import * as actions from "../actions";

import {
  faPencilAlt
} from "@fortawesome/fontawesome-free-solid";

const PREFIX_URL = 'https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/';

AOS.init({
  duration: 800
});

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      GUESTNAME: "",
      GUESTS: "",
      ATTEND: "",
      DIET: "",
      BABYCHAIR: "",
      HASHID: "",
      isMobile: false
    };

    this.updateMemberEntry  = this.updateMemberEntry.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.checkDeviceWidth = this.checkDeviceWidth.bind(this);
    this.image = [].concat(this.getStaticImages())
  }

  handleChange(event) {
    this.setState({ [event.target.name] : event.target.value});
  }

  updateMemberEntry(event) {
    var memberData = {};
        memberData = this.state;

        this.props.updateMailchimpListMember(memberData);
    event.preventDefault();
  }
  
  getParams() {

    var params = {},
        pairs = this.props.location.search.split('?')
               .pop()
               .split('&');
    for (var i = 0, p; i < pairs.length; i++) {
           p = pairs[i].split('=');
           params[ p[0] ] =  decodeURIComponent(p[1]);
    }     

    return params;
  }

  getStaticImages(){
    let images = [];
    for(let i=1; i< 42; i++){
      images.push({
        hd: `${PREFIX_URL}photo-${i}-hd.jpg`,
        original: `${PREFIX_URL}photo-${i}.jpg`,
        thumbnail: `${PREFIX_URL}thumb-${i}.jpg`,
        originalClass : `photo-square-${i}`,
      })
    }  

    return images;
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.images.mcUpdateStatus === "success") {
        this.props.history.push("/thank-you?rand=" + this.state.HASHID);
    }

    if (nextProps.images.mcFetchStatus === "success") { 
        this.setState({ GUESTNAME: nextProps.images.mcdata[0].GUESTNAME })
    }

  }

  componentWillMount() {
    this.props.images.mcUpdateStatus = "";
    var params = this.getParams();
    if(params.rand) {
      var rand = params.rand;
      this.setState({ HASHID: rand, GUESTS: 1})
      this.props.fetchMailchimpMember(rand);
    }
  }

  componentDidMount() {
    this.checkDeviceWidth();
    window.addEventListener("resize", this.checkDeviceWidth);
  }

  checkDeviceWidth() {
    if(window.innerHeight > window.innerWidth){
      this.setState({ isMobile: true })
    }else{
      this.setState({ isMobile: false })
    }
  }

  render() {
    return (
      <div className="main-wrapper homepage">
        <div className="homepage-paperbg"></div>
        <MetaTags>
          <title>Tuck and Rose: Wedding Lunch 23 December 2018 12pm @ Swissotel Merchant Court</title>
          <meta name="description" content="We're getting married! Please join us for our wedding lunch @ Swissotel Merchant Court. More to see and do on this site soon!" />
          <meta name="og:title" content="Tuck and Rose: Wedding Lunch 23 Dec 2018 12pm" />
          <meta name="og:site_name" content="Tuck and Rose" />
          <meta name="og:url" content="https://tuckandrose.family/" />
          <meta name="og:type" content="website" />
          <meta name="og:description" content="We're getting married! Please join us for our wedding lunch @ Swissotel Merchant Court. More to see and do on this site soon!" />
          <meta name="og:image" content="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/social.jpg" />
          <meta name="og:locale" content="en_SG" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Tuck and Rose: Wedding Lunch 23 Dec 2018 12pm" />
          <meta name="twitter:url" content="https://tuckandrose.family/" />
          <meta name="twitter:description" content="We're getting married! Please join us for our wedding lunch @ Swissotel Merchant Court. More to see and do on this site soon!" />
          <meta name="twitter:image:src" content="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/social.jpg" />
          <link rel="canonical" href="https://tuckandrose.family/" />
          <link rel="alternate" hrefLang="x-default" href="https://tuckandrose.family/" />
        </MetaTags>

        <iframe src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/jtv.mp3" allow="autoplay" style={{"display":"none"}} id="iframeAudio"></iframe> 
        
        
        <div className="main-wrapper-inner"> 
          <div className="container-floating">
            <div class="nd1 nds m-nds" data-toggle="tooltip">
              Share a Message!
            </div>
            <div className="share-message-wrapper d-flex align-items-center">
            <FontAwesomeIcon
                icon={faPencilAlt}
                onClick={() => {
                  this.props.history.push("nigoki")
                }}
              />
            </div>
          </div>
          <section className="main-content">
            <div className="master-header vh-100 valign-wrapper">
              {/* <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/flowers.png" alt="Flowers header" className="flower-header w-100" data-aos="zoom-out"/> */}
              {/* <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/mobile/flowers.png" alt="Flowers header" className="m-flower-header w-100 hide" data-aos="zoom-out"/> */}
              <div className="aligner-item center-align">
                <div className="container-fluid-max">
                <div className="row">
                  <div className="col s12 m7">
                  <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/banner-frame.png" className="w-100" data-aos="zoom-in"  data-aos-delay="200"/>
                  </div>
                  <div className="col s12 m5">
                    <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/tr-element.png" alt="" data-aos="zoom-in" width="80%" data-aos-delay="500" />
                    <div data-aos="fade-up" data-aos-delay="800" >
                      <p>Swissotel Merchant Court, Ballroom<br/>12:00pm, Sunday, 23&nbsp;December&nbsp;2018</p>
                      <hr className="purple" />
                      <p>Solemnization begins at 11:00am</p>
                    </div> 
                  </div>
                </div>
                </div>
              </div>
              <div className="flower-11" data-aos="zoom-in"></div>
              <div className="leaf-5" data-aos="zoom-in" data-aos-delay="600"></div>
              
            </div>
            <div className="gallery-header fluid-container-max center-align-sm center-align">
              <div className="flower-12" data-aos="zoom-in"></div>
              <div className="m-flower-1"  data-aos="zoom-in"></div>
              <div className="inner-content">
                <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/element-1.png" alt="" className="w-100"/>
                <p>&nbsp;</p>        
              </div>
              <div className="flower-13" data-aos="zoom-in" data-aos-delay="500"></div>
            </div>
            <div className="fluid-container-max gallery-container">
              
              <div data-aos="fade-up">
              {this.state.isMobile ? (<GalleryImagev1 galleryImages={this.image} /> ) : (<GalleryImagev2 galleryImages={this.image} /> )}
              </div>
            </div>
            <div className="fluid-container-max center-align-sm left-align">
              <div className="flower-14" data-aos="zoom-in"></div>
              <div className="flower-15" data-aos="zoom-in" data-aos-delay="200"></div>
              <div className="flower-16" data-aos="zoom-in" data-aos-delay="300"></div>
              <div className="flower-17" data-aos="zoom-in" data-aos-delay="400"></div>
              
              <div className="inner-content">
                <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/element-1.png" alt="" className="w-100"/>
                <h2 className="c-purple center-align mt">How to get here</h2>
                <div className="row">
                  <div className="col s12 m6 mb">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8095226813807!2d103.84373721470122!3d1.288463899060242!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da190abb1c2e8d%3A0x81504b4ffa8d3709!2sSwissotel+Merchant+Court+Singapore!5e0!3m2!1sen!2sph!4v1537857559833" className="venue-map" frameBorder="0" allowFullScreen></iframe>
                  </div>
                  <div className="col s12 m6">
                    <div data-aos="fade-up">
                      <h3>By Train (MRT)</h3>
                      <p>Clarke Quay Station (NE5)<br/>
                        (Within walking distance, approx. 2mins)</p>
                    </div>
                    <div data-aos="fade-up" data-aos-delay="300">
                      <h3 className="mt-5">By Bus</h3>
                      <p>Eu Tong Sen St - Opposite Hong Lim Park (05023)<br/>
                        2, 12, 33, 51, 61, 63, 80, 124, 166, 174, 197, 961, 2A, 12E, 174E<br/>
                        (Within walking distance, approx. 3mins)</p>
                    </div>
                  </div>
                  <div className="clear-fix"></div>
                </div>
              </div>
              {/* <div className="flower-1" data-aos="zoom-in"></div> */}
            </div>
            <div className="base-bg fluid-container-max center-align-sm mt-100">
              <div className="flower-18" data-aos="zoom-in" data-aos-delay="500"></div>
              <div className="m-flower-2"  data-aos="zoom-in"></div>
              <div data-aos="zoom-out">
                <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/base-placeholder.jpg" alt="Tuck and Rose" width="100%" />
                <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/base-flower-frame.png" alt="Base flower" className="base-flower w-100"/>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    images: state.images
  };
}

export default connect(mapStateToProps, actions)(HomePage);



// WEBPACK FOOTER //
// ./src/containers/HomePage.js